import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SafeHtmlPipe } from '../../../pipe/safe-html.pipe';
import { ButtonComponent } from '../../ui/button/button.component';
import { formatDate } from '../../../utils/date-format.util';

@Component({
    selector: 'app-account-inactive-modal',
    standalone: true,
    imports: [CommonModule, SafeHtmlPipe, ButtonComponent],
    templateUrl: './account-inactive-modal.component.html',
})
export class AccountInactiveModalComponent {
    @Input() isOpen = false;
    @Input() disabledDate: string | Date | undefined;
    @Output() backToLogin = new EventEmitter<void>();

    // Use the newly created SVG
    iconSvg = `
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20C10 14.4772 14.4772 10 20 10H60C65.5228 10 70 14.4772 70 20V50C70 55.5228 65.5228 60 60 60H20C14.4772 60 10 55.5228 10 50V20Z" stroke="#5C77FF" stroke-width="5" fill="none"/>
        <path d="M10 28H70" stroke="#5C77FF" stroke-width="4"/>
        <circle cx="20" cy="19" r="2.5" fill="#5C77FF"/>
        <circle cx="28" cy="19" r="2.5" fill="#5C77FF"/>
        <circle cx="36" cy="19" r="2.5" fill="#5C77FF"/>
        <circle cx="62" cy="62" r="16" fill="#5C77FF" stroke="white" stroke-width="4"/>
        <path d="M62 56V64" stroke="white" stroke-width="3" stroke-linecap="round"/>
        <circle cx="62" cy="70" r="2" fill="white"/>
    </svg>
    `;

    get formattedDate(): string {
        return formatDate(this.disabledDate, '');
    }

    onBackToLogin() {
        this.backToLogin.emit();
    }
}
